import React, { ReactChild } from 'react';
import Link from 'next/link';
import styles from './box.module.sass';

export const IconBox = ({ children }) => (
  <div className={styles.icon}>{children}</div>
);

export const Header = ({ children }) => (
  <h3 className={styles.header}>{children}</h3>
);

type Props = {
  enabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
  footnote?: ReactChild;
  children: ReactChild | ReactChild[];
};

const Box = ({ enabled = true, onClick, href, footnote, children }: Props) => {
  let statusStyle = enabled ? styles.enabled : styles.disabled;

  if (!children) {
    throw new Error('children are mandatory!');
  }

  const boxContents = (contents) => {
    if (href) {
      return (
        <div className={`${styles.box} ${statusStyle}`}>
          <Link href={href}>
            <a>{contents}</a>
          </Link>
        </div>
      );
    }
    return (
      <div className={`${styles.box} ${statusStyle}`} onClick={onClick}>
        {contents}
      </div>
    );
  };

  if (footnote) {
    return (
      <div className={styles.boxContainer}>
        {boxContents(children)}
        <div>
          <p className={`font-small ${styles.footnote}`}>{footnote}</p>
        </div>
      </div>
    );
  }

  return <div>{boxContents(children)}</div>;
};

export default Box;
